module.exports = __webpack_public_path__ + "img/mrbb.1ee87242.svg";